import { cn } from '@/lib/utils'
import { PosModel } from '@/types'

interface CategoryChipsProps {
  categories: PosModel.Category[]
  value?: string
  onChange: (id?: string) => void
}

const chip =
  'h-9 shrink-0 rounded-full px-4 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring'

/** One row of filter pills that scrolls sideways, as the admin's saved-view tabs. Tap the active one to clear. */
export const CategoryChips = ({ categories, value, onChange }: CategoryChipsProps) => (
  <div className="-ml-4 flex gap-2 overflow-x-auto pb-1 pl-4 scrollbar-hide">
    <button type="button" onClick={() => onChange(undefined)} className={cn(chip, !value ? 'bg-primary text-white' : 'bg-fill text-ink hover:bg-fill-hover')}>
      All
    </button>
    {categories.map((c) => (
      <button
        key={c._id}
        type="button"
        aria-pressed={value === c._id}
        onClick={() => onChange(value === c._id ? undefined : c._id)}
        className={cn(chip, value === c._id ? 'bg-primary text-white' : 'bg-fill text-ink hover:bg-fill-hover')}
      >
        {c.name}
      </button>
    ))}
  </div>
)
